var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle7, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoPosts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 346,
    height: 300,
    fill: "none",
    viewBox: "0 0 346 300",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178.471,
    cy: 147.728,
    r: 91.45,
    fill: "#ECF6EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.753,
    cy: 85.978,
    r: 5.732,
    fill: "#ECF6EF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.002,
    cy: 63.311,
    r: 10.682,
    fill: "#ECF6EF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.577,
    cy: 206.61,
    r: 10.161,
    fill: "#ECF6EF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.435,
    cy: 196.708,
    r: 10.161,
    fill: "#ECF6EF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.634,
    cy: 208.173,
    r: 4.95,
    fill: "#ECF6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8ECEA3",
    d: "M193.075 60.203c-.302-.064-.302-.495 0-.56l4.568-.97a.286.286 0 0 0 .22-.22l.983-4.535c.065-.3.494-.3.559 0l.984 4.535c.024.11.11.196.22.22l4.568.97c.302.065.302.496 0 .56l-4.568.972a.286.286 0 0 0-.22.219l-.984 4.535c-.065.301-.494.301-.559 0l-.983-4.535a.286.286 0 0 0-.22-.22l-4.568-.97ZM68.9 161.338c.116-.551.902-.551 1.019 0l1.742 8.229a.522.522 0 0 0 .399.402l8.144 1.774c.547.119.547.899 0 1.018l-8.144 1.774a.522.522 0 0 0-.4.402l-1.741 8.229c-.117.551-.903.551-1.02 0l-1.742-8.229a.522.522 0 0 0-.398-.402l-8.145-1.774c-.547-.119-.547-.899 0-1.018l8.145-1.774a.522.522 0 0 0 .398-.402l1.742-8.229Zm191.301-72.953c.116-.55.903-.55 1.019 0l1.016 4.8a.523.523 0 0 0 .399.402l4.765 1.038c.547.12.547.9 0 1.018l-4.765 1.038a.523.523 0 0 0-.399.401l-1.016 4.801c-.116.551-.903.551-1.019 0l-1.017-4.8a.52.52 0 0 0-.398-.402l-4.765-1.038c-.547-.119-.547-.899 0-1.018l4.765-1.038a.52.52 0 0 0 .398-.401l1.017-4.801Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m281.208 165.355 1.595 7.539 7.431 1.619-7.431 1.619-1.595 7.539-1.596-7.539-7.431-1.619 7.431-1.619 1.596-7.539Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93.904,
    height: 101.094,
    x: 172.399,
    y: 95.3,
    fill: "#fff",
    stroke: "#8ECEA3",
    strokeWidth: 2.084,
    rx: 5.467,
    transform: "rotate(10 172.399 95.3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 82.288,
    height: 71.779,
    x: 176.886,
    y: 101.707,
    fill: "#ECF6EF",
    stroke: "#ECF6EF",
    strokeWidth: 2.084,
    rx: 5.467,
    transform: "rotate(10 176.886 101.707)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 93.904,
    height: 101.094,
    x: 81.645,
    y: 111.608,
    fill: "#fff",
    stroke: "#8ECEA3",
    strokeWidth: 2.084,
    rx: 5.467,
    transform: "rotate(-10 81.645 111.608)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 82.288,
    height: 71.779,
    x: 88.053,
    y: 116.092,
    fill: "#ECF6EF",
    stroke: "#ECF6EF",
    strokeWidth: 2.084,
    rx: 5.467,
    transform: "rotate(-10 88.053 116.092)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 111.999,
    height: 120.606,
    x: 120.169,
    y: 87.02,
    fill: "#fff",
    stroke: "#8ECEA3",
    strokeWidth: 2.084,
    rx: 6.339
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 98.094,
    height: 85.513,
    x: 126.79,
    y: 93.641,
    fill: "#ECF6EF",
    stroke: "#8ECEA3",
    strokeWidth: 2.084,
    rx: 6.339
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.428,
    cy: 114.105,
    r: 7.742,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ECEA3",
    d: "M198.24 129.912a1.3 1.3 0 0 1 2.195 0l16.834 26.507a1.3 1.3 0 0 1-1.097 1.998h-33.669a1.301 1.301 0 0 1-1.098-1.998l16.835-26.507Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDE4CB",
    stroke: "#BDE4CB",
    strokeWidth: 2.084,
    d: "M160.186 112.953a.255.255 0 0 1 .436-.007l27.808 44.223a.256.256 0 0 1-.216.392h-53.823a.257.257 0 0 1-.221-.386l26.016-44.222Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159.867 110.683a.548.548 0 0 1 .942-.014l7.451 12.145c.311.507-.294 1.076-.781.735l-2.258-1.581a.55.55 0 0 0-.643.011l-3.22 2.415a.547.547 0 0 1-.551.062l-3.75-1.667a.549.549 0 0 0-.449.002l-3.445 1.566c-.485.22-.967-.31-.702-.771l7.406-12.903Zm40.034 17.391a.407.407 0 0 0-.699-.01l-5.529 9.011c-.23.376.219.798.58.545l1.656-1.159a.408.408 0 0 1 .501.027l2.36 2.066a.407.407 0 0 0 .465.049l2.739-1.521a.405.405 0 0 1 .365-.015l2.536 1.153a.407.407 0 0 0 .521-.573l-5.495-9.573Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDE4CB",
    strokeLinecap: "round",
    strokeWidth: 2.084,
    d: "M142.678 163.375h25.69"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8ECEA3",
    strokeLinecap: "square",
    strokeWidth: 2.084,
    d: "M128.708 158.41h95.358"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDE4CB",
    strokeLinecap: "round",
    strokeWidth: 2.084,
    d: "M161.328 167.422h16.544m-28.859.176h9.854m35.192-3.871h8.094"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPosts);
export { ForwardRef as ReactComponent };
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 346 300\"><circle cx=\"178.471\" cy=\"147.728\" r=\"91.45\" fill=\"#ECF6EF\"></circle><circle cx=\"92.753\" cy=\"85.978\" r=\"5.732\" fill=\"#ECF6EF\"></circle><circle cx=\"241.002\" cy=\"63.311\" r=\"10.682\" fill=\"#ECF6EF\"></circle><circle cx=\"94.577\" cy=\"206.61\" r=\"10.161\" fill=\"#ECF6EF\"></circle><circle cx=\"276.435\" cy=\"196.708\" r=\"10.161\" fill=\"#ECF6EF\"></circle><circle cx=\"256.634\" cy=\"208.173\" r=\"4.95\" fill=\"#ECF6EF\"></circle><path fill=\"#8ECEA3\" d=\"M193.075 60.203c-.302-.064-.302-.495 0-.56l4.568-.97a.286.286 0 0 0 .22-.22l.983-4.535c.065-.3.494-.3.559 0l.984 4.535c.024.11.11.196.22.22l4.568.97c.302.065.302.496 0 .56l-4.568.972a.286.286 0 0 0-.22.219l-.984 4.535c-.065.301-.494.301-.559 0l-.983-4.535a.286.286 0 0 0-.22-.22l-4.568-.97ZM68.9 161.338c.116-.551.902-.551 1.019 0l1.742 8.229a.522.522 0 0 0 .399.402l8.144 1.774c.547.119.547.899 0 1.018l-8.144 1.774a.522.522 0 0 0-.4.402l-1.741 8.229c-.117.551-.903.551-1.02 0l-1.742-8.229a.522.522 0 0 0-.398-.402l-8.145-1.774c-.547-.119-.547-.899 0-1.018l8.145-1.774a.522.522 0 0 0 .398-.402l1.742-8.229Zm191.301-72.953c.116-.55.903-.55 1.019 0l1.016 4.8a.523.523 0 0 0 .399.402l4.765 1.038c.547.12.547.9 0 1.018l-4.765 1.038a.523.523 0 0 0-.399.401l-1.016 4.801c-.116.551-.903.551-1.019 0l-1.017-4.8a.52.52 0 0 0-.398-.402l-4.765-1.038c-.547-.119-.547-.899 0-1.018l4.765-1.038a.52.52 0 0 0 .398-.401l1.017-4.801Z\"></path><path fill=\"#fff\" d=\"m281.208 165.355 1.595 7.539 7.431 1.619-7.431 1.619-1.595 7.539-1.596-7.539-7.431-1.619 7.431-1.619 1.596-7.539Z\"></path><rect width=\"93.904\" height=\"101.094\" x=\"172.399\" y=\"95.3\" fill=\"#fff\" stroke=\"#8ECEA3\" stroke-width=\"2.084\" rx=\"5.467\" transform=\"rotate(10 172.399 95.3)\"></rect><rect width=\"82.288\" height=\"71.779\" x=\"176.886\" y=\"101.707\" fill=\"#ECF6EF\" stroke=\"#ECF6EF\" stroke-width=\"2.084\" rx=\"5.467\" transform=\"rotate(10 176.886 101.707)\"></rect><rect width=\"93.904\" height=\"101.094\" x=\"81.645\" y=\"111.608\" fill=\"#fff\" stroke=\"#8ECEA3\" stroke-width=\"2.084\" rx=\"5.467\" transform=\"rotate(-10 81.645 111.608)\"></rect><rect width=\"82.288\" height=\"71.779\" x=\"88.053\" y=\"116.092\" fill=\"#ECF6EF\" stroke=\"#ECF6EF\" stroke-width=\"2.084\" rx=\"5.467\" transform=\"rotate(-10 88.053 116.092)\"></rect><rect width=\"111.999\" height=\"120.606\" x=\"120.169\" y=\"87.02\" fill=\"#fff\" stroke=\"#8ECEA3\" stroke-width=\"2.084\" rx=\"6.339\"></rect><rect width=\"98.094\" height=\"85.513\" x=\"126.79\" y=\"93.641\" fill=\"#ECF6EF\" stroke=\"#8ECEA3\" stroke-width=\"2.084\" rx=\"6.339\"></rect><circle cx=\"188.428\" cy=\"114.105\" r=\"7.742\" fill=\"#fff\"></circle><path fill=\"#8ECEA3\" d=\"M198.24 129.912a1.3 1.3 0 0 1 2.195 0l16.834 26.507a1.3 1.3 0 0 1-1.097 1.998h-33.669a1.301 1.301 0 0 1-1.098-1.998l16.835-26.507Z\"></path><path fill=\"#BDE4CB\" stroke=\"#BDE4CB\" stroke-width=\"2.084\" d=\"M160.186 112.953a.255.255 0 0 1 .436-.007l27.808 44.223a.256.256 0 0 1-.216.392h-53.823a.257.257 0 0 1-.221-.386l26.016-44.222Z\"></path><path fill=\"#fff\" d=\"M159.867 110.683a.548.548 0 0 1 .942-.014l7.451 12.145c.311.507-.294 1.076-.781.735l-2.258-1.581a.55.55 0 0 0-.643.011l-3.22 2.415a.547.547 0 0 1-.551.062l-3.75-1.667a.549.549 0 0 0-.449.002l-3.445 1.566c-.485.22-.967-.31-.702-.771l7.406-12.903Zm40.034 17.391a.407.407 0 0 0-.699-.01l-5.529 9.011c-.23.376.219.798.58.545l1.656-1.159a.408.408 0 0 1 .501.027l2.36 2.066a.407.407 0 0 0 .465.049l2.739-1.521a.405.405 0 0 1 .365-.015l2.536 1.153a.407.407 0 0 0 .521-.573l-5.495-9.573Z\"></path><path stroke=\"#BDE4CB\" stroke-linecap=\"round\" stroke-width=\"2.084\" d=\"M142.678 163.375h25.69\"></path><path stroke=\"#8ECEA3\" stroke-linecap=\"square\" stroke-width=\"2.084\" d=\"M128.708 158.41h95.358\"></path><path stroke=\"#BDE4CB\" stroke-linecap=\"round\" stroke-width=\"2.084\" d=\"M161.328 167.422h16.544m-28.859.176h9.854m35.192-3.871h8.094\"></path></svg>";